// extracted by css-extract-rspack-plugin
export default {"modalRoot":"RiDL_","modalHeader":"ZsHmC","modalBody":"bJWYd"};